<template>
  <div class="hotel-edit-accordion-9">
    <!-- TÍTULO -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Gateway
    </PmwHeading>

    <div class="form--row form--row__spacing-bigger form--row__wrap">
      <!-- GATEWAY DE PAGAMENTO -->
      <PmwFormSelect
        :value="gateway"
        :options="gatewayPayments"
        :search="true"
        :required="true"
        :infoIcon="true"
        tooltipMinWidth="165"
        infoText="Define qual serviço de pagamento o hotel utiliza."
        label="Gateway de Pagamento"
        placeholder="Selecione o gateway"
        class="form--input form--input__bigger"
        @input="$emit('changeGateway', $event)"
      />

      <!-- MUNDIPAGG -->
      <PmwFormInput
        :value="mundipagg1"
        :required="false"
        :infoIcon="true"
        tooltipMinWidth="236"
        infoText="Chave pública para integração com Mundipagg. Dado disponível dentro da Mundipagg / Desenvolvimento /Chaves"
        label="Mundipagg Public Key"
        placeholder="Insira o Public Key"
        class="form--input"
        @input="$emit('changeMundipagg1', $event)"
      />

      <!-- MUNDIPAGG -->
      <PmwFormInput
        :value="mundipagg2"
        :infoIcon="true"
        tooltipMinWidth="236"
        infoText="Chave secreta para integração com Mundipagg. Dado disponível dentro da Mundipagg / Desenvolvimento /Chaves"
        label="Mundipagg Secret Key"
        placeholder="Insira o Secret Key"
        class="form--input"
        @input="$emit('changeMundipagg2', $event)"
      />

      <!-- CLEARSALE -->
      <PmwFormInput
        :value="clearsale"
        :infoIcon="true"
        tooltipMinWidth="198"
        infoText="ID do Fingerprint da Clearsale. Dado disponível no e-mail de criação da loja pela Clearsale"
        label="Clearsale Fingerprint ID"
        placeholder="Insira o Fingerprint ID"
        class="form--input"
        @input="$emit('changeClearsale', $event)"
      />

      <!-- MUNDIPAGG ID DA CONTA -->
      <PmwFormInput
        :value="mundipaggAccountID"
        :required="false"
        :infoIcon="true"
        tooltipMinWidth="236"
        infoText="ID da conta criada na Pagarme para integração da Carteira Digital. Dado disponível dentro da Mundipagg / Configurações / Chaves / ID da Conta"
        label="Mundipagg ID da Conta"
        placeholder="Insira o Mundipagg ID da Conta"
        class="form--input"
        @input="$emit('changeMundipaggAccountID', $event)"
      />

      <!-- MUNDIPAGG GOOGLE PAY ID -->
      <PmwFormInput
        :value="googlePayMerchantId"
        :required="false"
        label="Mundipagg Google Pay ID"
        placeholder="Insira o Mundipagg Google Pay ID"
        class="form--input"
        @input="$emit('changeGooglePayMerchantId', $event)"
      />
    </div>

    <div class="form--row form--row__spacing-bigger form--row__margin-bigger">
      <!-- ACQUIRER -->
      <PmwFormSelect
        :value="acquirer"
        :options="acquirerList"
        :search="true"
        :infoIcon="true"
        tooltipMinWidth="203"
        infoText="Informe o adquirente que o hotel utiliza. Dado que será enviado em algumas integrações com PMS."
        label="Acquirer"
        placeholder=""
        class="form--input form--input__bigger"
        @input="$emit('changeAcquirer', $event)"
      />

      <!-- ESTORNO AUTOMÁTICO -->
      <div class="form--group-radio">
        <PmwParagraph
          size="paragraph-60"
          weight="medium"
          class="form--subtitle"
        >
          Estorno Automático
          <PmwInfoTooltip width="165px">
            <template #content>
              Ative ou desative o estorno automático neste hotel.
            </template>
          </PmwInfoTooltip>
        </PmwParagraph>
        <div class="form--row-checklist">
          <!-- ATIVO -->
          <PmwInputRadio
            :value="reversal"
            :checked="reversal"
            :inputValue="true"
            label="Ativo"
            name="reversal"
            @input="$emit('changeReversal', $event)"
          />
          <!-- INATIVO -->
          <PmwInputRadio
            :value="reversal"
            :checked="!reversal"
            :inputValue="false"
            label="Inativo"
            name="reversal"
            @input="$emit('changeReversal', $event)"
          />
        </div>
      </div>

      <!-- HABILITAR ANTIFRAUDE -->
      <div class="form--group-radio">
        <PmwParagraph
          size="paragraph-60"
          weight="medium"
          class="form--subtitle"
        >
          Habilitar Antifraude
          <PmwInfoTooltip width="135px">
            <template #content>
              Ative ou desative o antifraude neste hotel.
            </template>
          </PmwInfoTooltip>
        </PmwParagraph>
        <div class="form--row-checklist">
          <!-- ATIVO -->
          <PmwInputRadio
            :value="antiFraud"
            :checked="antiFraud"
            :inputValue="true"
            label="Ativo"
            name="antiFraud"
            @input="$emit('changeAntiFraud', $event)"
          />
          <!-- INATIVO -->
          <PmwInputRadio
            :value="antiFraud"
            :checked="!antiFraud"
            :inputValue="false"
            label="Inativo"
            name="antiFraud"
            @input="$emit('changeAntiFraud', $event)"
          />
        </div>
      </div>
    </div>

    <!-- PAGAMENTO -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Pagamento
    </PmwHeading>

    <div class="form--row form--row__margin-bigger">
      <!-- HABILITAR PIX -->
      <div class="form--group-radio">
        <PmwParagraph
          size="paragraph-60"
          weight="medium"
          class="form--subtitle"
        >
          Habilitar Pix
          <PmwInfoTooltip width="192px">
            <template #content>
              Define se deve permitir pagamento com PIX. ID do hotel retirado do
              painel da Starkbank.
            </template>
          </PmwInfoTooltip>
        </PmwParagraph>

        <div class="form--row-checklist">
          <!-- ATIVO -->
          <PmwInputRadio
            :value="pix"
            :checked="pix"
            :inputValue="true"
            label="Ativo"
            name="pix"
            @input="$emit('changePix', $event)"
          />
          <!-- INATIVO -->
          <PmwInputRadio
            :value="pix"
            :checked="!pix"
            :inputValue="false"
            label="Inativo"
            name="pix"
            @input="$emit('changePix', $event)"
          />
        </div>
      </div>
      <div v-if="pix" class="input--container">
        <!-- PARCEIRO - PAGAMENTO PIX -->
        <PmwFormSelect
          :value="gatewayPix"
          :options="gatewayPixList"
          :search="true"
          :required="true"
          label="Parceiro"
          placeholder="Selecione o parceiro"
          class="form--input form--input__payment-type"
          @input="$emit('changeGatewayPix', $event)"
        />

        <!-- SE O PARCEIRO SELECIONADO FOR O "STARBANK" -->
        <template v-if="gatewayPix?.value === 'STARKBANK'">
          <!-- ID STARBANK -->
          <PmwFormInput
            :value="starbank"
            :infoIcon="true"
            :disabled="starbankFill"
            tooltipMinWidth="207"
            infoText="Informar o ID ao qual foi aberto a conta no Starkbank pós inserção da chave publica enviado por nós"
            label="ID Starkbank"
            placeholder="Insira o ID Starbank"
            @input="$emit('changeStarbank', $event)"
          />

          <PmwButton
            :disabled="disabledStarkbankButtons"
            layout="outline"
            variation="blue-100"
            class="button__outline form--button"
            @click="publicKey()"
          >
            Chave Pública
          </PmwButton>

          <PmwButton
            :disabled="disabledStarkbankButtons"
            :tooltipText="
              'Esse processo já foi realizado. Caso queira alterar dados, precisará solicitar a exclusão para o time.'
            "
            :popperStrategy="'auto'"
            layout="outline"
            variation="blue-100"
            class="button__outline form--button"
            showInfo
            @click="validateIntegration()"
          >
            Finalizar Configuração
          </PmwButton>
        </template>

        <!-- SE O PARCEIRO SELECIONADO FOR O "CIELO" -->
        <template v-if="gatewayPix?.value === 'CIELO'">
          <!-- CIELO MERCHANT ID -->
          <PmwFormInput
            :value="cieloMerchantId"
            :required="false"
            label="Cielo Merchant ID"
            placeholder="Insira o ID"
            @input="$emit('changecieloMerchantId', $event)"
          />

          <!-- CIELO MERCHANT KEY -->
          <PmwFormInput
            :value="cieloMerchantKey"
            label="Cielo Merchant Key"
            placeholder="Insira a Key"
            @input="$emit('changecieloMerchantKey', $event)"
          />
        </template>

        <!-- SE O PARCEIRO SELECIONADO FOR O "REDECARD" -->
        <template v-if="gatewayPix?.value === 'REDECARD'">
          <!-- REDECARD CLIENT ID -->
          <PmwFormInput
            :value="redecardClientId"
            :required="false"
            label="Redecard clientId"
            placeholder="Insira o clientId"
            @input="$emit('changeRedecardClientId', $event)"
          />

          <!-- REDECARD CLIENT SECRET -->
          <PmwFormInput
            :value="redecardClientSecret"
            label="Redecard clientSecret"
            placeholder="Insira o clientSecret"
            @input="$emit('changeRedecardClientSecret', $event)"
          />
        </template>

        <!-- RESETAR OS DADOS SE JÁ PREENCHIDOS -->
        <PmwButton
          v-if="pix && (starbankFill || cieloMerchantKeyFill)"
          layout="outline"
          variation="error-100"
          class="button__outline form--button"
          @click="showResetConfirmation"
        >
          Resetar Dados
        </PmwButton>
      </div>
    </div>

    <!-- CONFIGURAÇÕES DO HOTEL -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Configurações do Hotel
    </PmwHeading>

    <div class="form--row form--row__margin-bigger">
      <!-- TARIFÁRIO DO HOTEL -->
      <PmwFormSelect
        :value="tariff"
        :options="tariffList"
        :search="true"
        :infoIcon="true"
        :required="true"
        tooltipMinWidth="185"
        infoText="Indica se o hotel tem o tarifário flutuante ou absoluto."
        label="Tarifário do Hotel"
        placeholder="Selecione o tarifário"
        class="form--input form--input__bigger"
        @input="$emit('changeTariff', $event)"
      />

      <!-- PAX COMPOSTO -->
      <PmwFormSelect
        :value="pax"
        :options="paxList"
        :search="true"
        :infoIcon="true"
        :required="true"
        :disabled="isAbsolute"
        tooltipMinWidth="264"
        infoText="Indica se o hotel considera os valores de diferenciais à ocupação anterior (Composto) ou soma dos valores de todas ocupações para considerar os diferenciais (Normal)."
        label="Pax Composto"
        placeholder="Selecione o pax"
        class="form--input form--input__bigger"
        @input="$emit('changePax', $event)"
      />

      <!-- PMS DO HOTEL -->
      <PmwFormSelect
        :value="pms"
        :options="pmsList"
        :search="true"
        :infoIcon="true"
        tooltipMinWidth="181"
        infoText="Indica qual é o PMS utilizado por este hotel com integração via Letsbook."
        label="PMS do Hotel"
        placeholder="Selecione o PMS"
        class="form--input form--input__bigger"
        @input="$emit('changePms', $event)"
      />
    </div>
    <div class="form--row form--row__margin-bigger">
      <!-- VALOR MÍNIMO DA DIÁRIA -->
      <PmwFormInput
        v-only-numbers
        :value="minRateValue"
        :required="true"
        :infoIcon="true"
        :sufix="currency"
        :min="1"
        :error="errors.includes('valorMinimoDiaria')"
        data-error="valorMinimoDiaria"
        tooltipMinWidth="155"
        infoText="Este campo define o valor mínimo aceitável para tarifas neste hotel. Tarifas cadastradas abaixo deste valor irão disparar um alerta por e-mail."
        type="number"
        label="Valor mínimo da diária"
        placeholder="00"
        class="form--input"
        @input="$emit('changeMinRateValue', +$event)"
      />

      <!-- TIPO DE HOTEL -->
      <PmwFormSelect
        :value="type"
        :options="types"
        :search="true"
        :required="true"
        :infoIcon="true"
        tooltipMinWidth="185"
        infoText="Define o tipo de hotel para categorização e análise de dados no BigQuery."
        label="Tipo de Hotel"
        placeholder="Selecione o tipo"
        class="form--input form--input__hotel-type"
        @input="$emit('changeType', $event)"
      />
    </div>

    <!-- PARÂMETRO DO HOTEL -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Parâmetro do hotel
    </PmwHeading>

    <div class="form--row form--row__spacing-bigger form--row__margin-bigger">
      <!-- MÍNIMO DE NOITES -->
      <PmwFormInput
        :value="minNights"
        :required="true"
        :infoIcon="true"
        :error="errors.includes('minimoNoites')"
        data-error="minimoNoites"
        tooltipMinWidth="155"
        infoText="Mínimo de noites obrigatório para reserva."
        type="number"
        label="Mínimo de noites"
        placeholder="Insira o mínimo de noites"
        class="form--input"
        @input="$emit('changeMinNights', $event)"
      />

      <!-- MÍNIMO DE ADULTOS -->
      <PmwFormInput
        :value="minAdults"
        :required="true"
        :infoIcon="true"
        :error="errors.includes('NumeroAdultos')"
        data-error="NumeroAdultos"
        tooltipMinWidth="155"
        infoText="Número de adultos padrões para pesquisa."
        type="number"
        label="Número de adultos"
        placeholder="Insira o número de adultos"
        class="form--input"
        @input="$emit('changeMinAdults', $event)"
      />

      <PmwButton
        v-if="hotelId"
        layout="outline"
        variation="blue-100"
        class="button__outline form--button"
        @click="$emit('changeShowProcessRates', true)"
      >
        Processar
        <PmwInfoTooltip width="235px" class="pmw-info-tooltip__fill">
          <template #content>
            Caso seja necessário processar todo o hotel no âmbito de tarifas e
            flutuações podemos forçar o processamento clicando neste botão.
          </template>
        </PmwInfoTooltip>
      </PmwButton>
    </div>

    <!-- CONFIGURAÇÕES DE CRIANÇAS -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Configuração de crianças
    </PmwHeading>

    <div class="form--row form--row__spacing-bigger form--row__margin-bigger">
      <!-- ACEITA CRIANÇAS -->
      <div class="form--group-radio">
        <PmwParagraph
          size="paragraph-60"
          weight="medium"
          class="form--subtitle"
        >
          Aceita crianças? <span class="form--asterisk">*</span>
          <PmwInfoTooltip width="175px">
            <template #content>
              Indica se crianças são permitidas ou não no hotel
            </template>
          </PmwInfoTooltip>
        </PmwParagraph>

        <div class="form--row-checklist">
          <!-- SIM -->
          <PmwInputRadio
            :value="allowChildren"
            :checked="allowChildren"
            :inputValue="true"
            label="Sim"
            name="allowChildren"
            @input="$emit('changeAllowChildren', $event)"
          />

          <!-- NÃO -->
          <PmwInputRadio
            :value="allowChildren"
            :checked="!allowChildren"
            :inputValue="false"
            label="Não"
            name="allowChildren"
            @input="$emit('changeAllowChildren', $event)"
          />
        </div>
      </div>

      <!-- IDADE MÍNIMA CRINÇA -->
      <PmwFormInput
        :value="minAgeChildren"
        :error="errors.includes('IdadeMinimaCriancas')"
        :required="true"
        :disabled="!allowChildren"
        data-error="IdadeMinimaCriancas"
        type="number"
        label="Idade mínima criança"
        placeholder="00"
        class="form--input"
        @input="$emit('changeMinAgeChildren', $event)"
        @blur="blurChildrenAge('Min')"
      />

      <!-- IDADE MÁXIMA CRINÇA -->
      <PmwFormInput
        :value="maxAgeChildren"
        :error="errors.includes('IdadeMaximaCriancas')"
        :required="true"
        :disabled="!allowChildren"
        data-error="IdadeMaximaCriancas"
        type="number"
        label="Idade máxima criança"
        placeholder="00"
        class="form--input"
        @input="$emit('changeMaxAgeChildren', $event)"
        @blur="blurChildrenAge('Max')"
      />
    </div>

    <!-- CONFIGURAÇÕES DE FAIXA ETÁRIA -->
    <PmwHeading
      v-if="allowChildren"
      id="faixa-etaria"
      size="paragraph-80"
      weight="weight-light"
      class="form--title"
    >
      Configuração de faixa etária infantil
    </PmwHeading>

    <!-- IDADE MÍNIMA CRINÇA -->
    <div
      v-for="(ageGroup, index) in ageGroups"
      :key="index"
      :class="{ 'form--row__margin-bigger': index + 1 === ageGroups.length }"
      class="form--row"
    >
      <PmwFormInput
        v-model="ageGroup.idadeMinima"
        :error="errors.includes('IdadeMinima|IdadeMaxima')"
        :hasMask="true"
        :mask="'##'"
        :disabled="!allowChildren"
        data-error="IdadeMinima|IdadeMaxima"
        sufix="Anos"
        label="Entre"
        placeholder="0"
        class="form--input form--input__age"
        @blur="
          ageGroup.idadeMinima = clampNumber(
            ageGroup.idadeMinima,
            minAgeChildren,
            maxAgeChildren
          )
        "
      />

      <span class="form--row__message">a</span>

      <PmwFormInput
        v-model="ageGroup.idadeMaxima"
        :error="errors.includes('IdadeMinima|IdadeMaxima')"
        :hasMask="true"
        :mask="'##'"
        :disabled="!allowChildren"
        data-error="IdadeMinima|IdadeMaxima"
        sufix="Anos"
        label=""
        placeholder="0"
        class="form--input form--input__age"
        @blur="
          ageGroup.idadeMaxima = clampNumber(
            ageGroup.idadeMaxima,
            ageGroup.idadeMinima || minAgeChildren,
            maxAgeChildren
          )
        "
      />

      <!-- PAGAMENTO -->
      <PmwFormSelect
        v-if="isAbsolute"
        v-model="ageGroup.pagante"
        :options="childrenTypes"
        :search="true"
        :disabled="!allowChildren"
        label="Pagamento"
        placeholder=""
        class="form--input form--input__lower"
      />

      <!-- ADICIONAR FAIXA ETÁRIA -->
      <PmwButton
        v-if="index + 1 === ageGroups.length && ageGroups.length < 2"
        :hasIcon="true"
        :disabled="!allowChildren"
        layout="outline"
        variation="blue-100"
        class="button__outline form--button"
        @click="addAgeGroup()"
      >
        Adicionar faixa etária
      </PmwButton>

      <!-- REMOVER FAIXA ETÁRIA -->
      <PmwButton
        v-if="index + 1 < ageGroups.length"
        :hasIcon="false"
        :disabled="!allowChildren"
        layout="outline"
        variation="error-100"
        class="button__outline form--button"
        @click="removeAgeGroup(index)"
      >
        Remover faixa etária
      </PmwButton>
    </div>

    <!-- CONFIGURAÇÕES DE INTEGRAÇÕES -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Configuração de Integrações
    </PmwHeading>

    <div class="form--row">
      <!-- GRAD ID -->
      <PmwFormInput
        :value="gtadId"
        label="Gtag ID"
        placeholder="Insira o ID do Gtag"
        class="form--input form--input__lower"
        @input="$emit('changeGtadId', $event)"
      />

      <!-- GRAD AW -->
      <PmwFormInput
        :value="gtadAw"
        label="Gtag ID"
        placeholder="Insira o Gtag AW"
        class="form--input form--input__lower"
        @input="$emit('changeGtadAw', $event)"
      />

      <!-- OTA -->
      <PmwFormInput
        :value="ota"
        :infoIcon="true"
        tooltipMinWidth="188"
        infoText="Subscription ID da OTA Insight."
        label="OTA Insight ID"
        placeholder="Insira o ID"
        class="form--input form--input__lower"
        @input="$emit('changeOta', $event)"
      />

      <!-- PAGAMENTO -->
      <PmwFormSelect
        :value="otaInsights"
        :error="errors.includes('otaInsights')"
        :disabled="!ota"
        :options="otaTypes"
        :toggleAll="false"
        :search="true"
        :multiple="true"
        :required="ota?.length > 0"
        data-error="otaInsights"
        label="OTAs"
        placeholder=""
        class="form--input form--input__bigger"
        @input="$emit('changeOtaInsights', $event)"
      />
    </div>

    <!-- CHATBOT DE ABANDONO -->
    <div class="form--row chatbot-block">
      <PmwFormField
        label="Abandono via chatbot"
        size="small"
        class="chatbot-block--radio"
      >
        <div class="chatbot-block--radio-content">
          <PmwInputRadio
            :value="hasChatbotCartDrop"
            :checked="!hasChatbotCartDrop"
            :inputValue="false"
            name="hasChatbotCartDrop"
            label="Não"
            @input="$emit('changeHasChatbotCartDrop', $event)"
          />

          <PmwInputRadio
            :value="hasChatbotCartDrop"
            :checked="hasChatbotCartDrop"
            :inputValue="true"
            name="hasChatbotCartDrop"
            label="Sim"
            @input="$emit('changeHasChatbotCartDrop', $event)"
          />
        </div>
      </PmwFormField>

      <transition name="fade-fast">
        <PmwFormSelect
          v-if="hasChatbotCartDrop"
          :value="
            chatbotCartDropOptions.find(
              (item) => item.value === chatbotCartDrop
            )
          "
          :options="chatbotCartDropOptions"
          :required="hasChatbotCartDrop"
          :error="errors.includes('TipoIntegracaoAbandonoChatbot')"
          data-error="TipoIntegracaoAbandonoChatbot"
          label="Parceiro de chatbot"
          class="form--input form--input__oversized"
          size="fluid"
          @input="$emit('changeChatbotCartDrop', $event)"
        />
      </transition>
    </div>
    <!-- FIM CHATBOT DE ABANDONO -->

    <!-- ECOMMERCE TRIP ADVISOR -->
    <div class="form--row chatbot-block">
      <PmwFormField
        label="Tripadvisor para venda do Ecommerce"
        size="fluid"
        class="chatbot-block--radio"
      >
        <div class="chatbot-block--radio-content">
          <!-- SIM -->
          <PmwInputRadio
            :value="tripAdvisorEcommerce"
            :checked="tripAdvisorEcommerce"
            :inputValue="true"
            label="Ativo"
            name="tripAdvisorEcommerce"
            @input="$emit('changeTripAdvisorEcommerce', $event)"
          />

          <!-- NÃO -->
          <PmwInputRadio
            :value="tripAdvisorEcommerce"
            :checked="!tripAdvisorEcommerce"
            :inputValue="false"
            label="Inativo"
            name="tripAdvisorEcommerce"
            @input="$emit('changeTripAdvisorEcommerce', $event)"
          />
        </div>
      </PmwFormField>
    </div>

    <!-- PONTOS -->
    <div class="form--row chatbot-block">
      <PmwFormField
        label="Habilitar pagamento por pontos"
        size="fluid"
        class="chatbot-block--radio"
      >
        <div class="chatbot-block--radio-content">
          <PmwInputRadio
            :value="hasPoints"
            :checked="hasPoints"
            :inputValue="true"
            :class="{ 'chatbot-block--radio-content__disabled': !hotelId }"
            name="hasPoints"
            label="Sim"
            @input="$emit('changeHasPoints', $event)"
          />

          <PmwInputRadio
            :value="hasPoints"
            :checked="!hasPoints"
            :inputValue="false"
            name="pointsSelection"
            label="Não"
            @input="$emit('changeHasPoints', $event)"
          />
        </div>
      </PmwFormField>
    </div>

    <transition-group name="fade-fast">
      <div v-if="hasPoints" :key="'points-partner'" class="form--row">
        <PmwFormSelect
          :value="pointsType"
          :options="itemsIncludePoints"
          :required="hasPoints"
          :error="errors.includes('UtilizaPontos')"
          data-error="UtilizaPontos"
          label="Selecione o parceiro de pontos"
          class="form--input form--input__oversized"
          @input="$emit('changePointsType', $event)"
        />
      </div>

      <div v-if="hasPoints" :key="'points-utilization'" class="form--row">
        <PmwFormField
          label="Forma de utilização de pontos"
          size="fluid"
          class="chatbot-block--radio"
        >
          <div class="chatbot-block--radio-content">
            <PmwInputRadio
              :value="pointsSelection"
              :checked="pointsSelection === 1"
              :inputValue="1"
              name="pointsSelection"
              label="Valor fixo"
              @input="$emit('changePointSelection', $event)"
            />

            <PmwInputRadio
              :value="pointsSelection"
              :checked="pointsSelection === 2"
              :inputValue="2"
              name="pointsSelection"
              label="Valor convertido manual"
              @input="$emit('changePointSelection', $event)"
            />

            <PmwInputRadio
              v-if="tariff.value"
              :value="pointsSelection"
              :checked="pointsSelection === 3"
              :inputValue="3"
              name="pointsSelection"
              label="Valor convertido automaticamente"
              @input="$emit('changePointSelection', $event)"
            />
          </div>
        </PmwFormField>
      </div>

      <div v-if="hasPoints" :key="'points-values'" class="form--row">
        <transition name="fade-fast-out-abs">
          <PmwFormInput
            v-if="pointsSelection === 1"
            :value="pointsPerNight"
            :error="errors.includes('UtilizaPontos')"
            data-error="UtilizaPontos"
            label=""
            placeholder="200"
            size="small"
            sufix="$ por noite"
            type="number"
            @input="$emit('pointsPerNightInput', $event)"
          />
        </transition>

        <transition name="fade-fast-out-abs">
          <PmwFormInput
            v-if="pointsSelection === 2 || pointsSelection === 3"
            :value="pointsPerReal"
            :error="errors.includes('UtilizaPontos')"
            data-error="UtilizaPontos"
            label=""
            placeholder="200"
            size="small"
            sufix="pts a cada real"
            type="number"
            @input="$emit('pointsPerRealInput', $event)"
          />
        </transition>

        <transition name="fade-fast">
          <PmwFormSelect
            v-if="pointsSelection === 3"
            :value="baseTariff"
            :options="absoluteRatesOptions"
            :disabled="absoluteRatesOptions.length === 1"
            :required="pointsSelection === 3"
            label="Selecione a tarifa base"
            class="form--input form--input__base-tariff"
            @input="$emit('changeBaseTariff', $event)"
          />
        </transition>
      </div>
    </transition-group>

    <!-- CELULAR SMS -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Celular SMS
      <PmwInfoTooltip width="203px">
        <template #content>
          Celular usado para o envio de SMS (quando contratado) alertando sobre
          reservas para o Hotel
        </template>
      </PmwInfoTooltip>
    </PmwHeading>

    <div class="form--row form--row__spacing-bigger form--row__margin-bigger">
      <!-- PAÍS TELEFONE -->
      <PmwFormSelect
        :value="phoneContry"
        :options="ddi"
        :search="true"
        label="País/Região"
        placeholder=""
        class="form--input form--input__phone-country"
        @input="$emit('changePhoneContry', $event)"
      />

      <!-- DDD -->
      <PmwFormInput
        :value="phonePrefix"
        :error="errors.includes('CelularSMS.DDD')"
        :hasMask="true"
        :mask="phoneContry && phoneContry.number === '55' ? '##' : '#####'"
        data-error="CelularSMS.DDD"
        label="Prefixo"
        placeholder="00"
        class="form--input__prefix"
        @input="$emit('changePhonePrefix', $event)"
      />

      <!-- NÚMERO DE TELEFONE -->
      <PmwFormInput
        :value="phoneNumber"
        :error="errors.includes('CelularSMS.Numero')"
        :hasMask="true"
        :mask="
          phoneContry && phoneContry.number === '55'
            ? ['####-####', '#####-####']
            : '###############'
        "
        data-error="CelularSMS.Numero"
        label="Telefone"
        placeholder="0 0000-0000"
        class="form--input__phone-number"
        @input="$emit('changePhoneNumber', $event)"
      />
    </div>

    <!-- OUTRAS CONFIGURAÇÕES -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Outras configurações
    </PmwHeading>

    <div class="form--row form--row__spacing-bigger form--row--others-config">
      <div class="form--container-radio">
        <div class="form--group-radio">
          <PmwParagraph
            size="paragraph-60"
            weight="medium"
            class="form--subtitle"
          >
            Exibe hotel?
            <PmwInfoTooltip width="187px">
              <template #content>
                Exiba ou oculte este este hotel.
              </template>
            </PmwInfoTooltip>
          </PmwParagraph>

          <div class="form--row-checklist">
            <!-- SIM -->
            <PmwInputRadio
              :value="showHotel"
              :checked="showHotel"
              :inputValue="true"
              label="Sim"
              name="showHotel"
              @input="$emit('changeShowHotel', $event)"
            />

            <!-- NÃO -->
            <PmwInputRadio
              :value="showHotel"
              :checked="!showHotel"
              :inputValue="false"
              label="Não"
              name="showHotel"
              @input="$emit('changeShowHotel', $event)"
            />
          </div>
        </div>
        <!-- BLOQUEAR PRÉ CHECKIN -->
        <div class="form--group-radio">
          <PmwParagraph
            size="paragraph-60"
            weight="medium"
            class="form--subtitle"
          >
            Bloquear Pré Check-in?
            <PmwInfoTooltip width="197px">
              <template #content>
                Caso o hotel não queira fornecer a opção do hóspede preencher os
                dados do web check-in, poderá marcar essa opção.
              </template>
            </PmwInfoTooltip>
          </PmwParagraph>

          <div class="form--row-checklist">
            <!-- SIM -->
            <PmwInputRadio
              :value="blockCheckin"
              :checked="blockCheckin"
              :inputValue="true"
              label="Sim"
              name="blockCheckin"
              @input="$emit('changeBlockCheckin', $event)"
            />

            <!-- NÃO -->
            <PmwInputRadio
              :value="blockCheckin"
              :checked="!blockCheckin"
              :inputValue="false"
              label="Não"
              name="blockCheckin"
              @input="$emit('changeBlockCheckin', $event)"
            />
          </div>
        </div>
      </div>
      <!-- LINK DE PRÉ-CHECKIN -->
      <div
        v-if="!blockCheckin"
        class="form--row form--row__margin-bigger form--row__block-checkin"
      >
        <div class="example-link">
          <PmwHeading
            size="paragraph-40"
            weight="bold"
            class="example-link--title"
            >Exemplo de parâmetros URL do Lets Sites
          </PmwHeading>
          <PmwParagraph
            size="paragraph-40"
            weight="bold"
            class="example-link--content"
          >
            https://meuhotel.com.br/checkin?checkin=<strong>%DTPREVISTA_INICIAL%</strong>&<strong>ReservationCode=%NumreservaGDS%</strong>&<strong
              >Surname=%Sobrenome%</strong
            >
          </PmwParagraph>
        </div>
        <PmwFormInput
          :value="preCheckinLink"
          maxlength="500"
          label="Link para Pré-Check-in"
          placeholder="Digite a url de Pré-Check-in"
          class="form--input form--input__url"
          @input="$emit('preCheckinLinkInput', $event)"
        />
      </div>
    </div>

    <!-- CRM -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      CRM
      <PmwInfoTooltip width="251px">
        <template #content>
          URL Integração do hotel. Basta preencher corretamente o final da url
          do cliente e clicar em 'Obter Dados' para que todos os campos sejam
          populados corretamente
        </template>
      </PmwInfoTooltip>
    </PmwHeading>

    <div class="form--row form--row__margin-bigger">
      <!-- URL -->
      <PmwFormInput
        :value="url"
        :error="errors.includes('UrlIntegracaoCrm')"
        data-error="UrlIntegracaoCrm"
        prefix="http://crm.pmweb.com.br/"
        inputPaddingLeft="170px"
        label="URL Integração"
        placeholder="Digite o final da url"
        class="form--input form--input__url"
        @input="$emit('changeUrl', $event)"
      />

      <!-- ID DE INTEGRAÇÃO -->
      <PmwFormInput
        :value="idIntegration"
        disabled
        label="Id integração"
        placeholder="-"
        class="form--input form--input__min"
        @input="$emit('changeIdIntegration', $event)"
      />

      <!-- USUÁRIO INTEGRAÇÃO -->
      <PmwFormInput
        :value="userIntegration"
        disabled
        label="Usuário integração"
        placeholder="-"
        class="form--input form--input__min"
        @input="$emit('changeUserIntegration', $event)"
      />

      <!-- SENHA -->
      <PmwFormInput
        :value="password"
        disabled
        label="Senha"
        placeholder="-"
        class="form--input form--input__min"
        @input="$emit('changePassword', $event)"
      />
    </div>

    <!-- PARAMETRIZAÇÃO DE TAXAS -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Parametrização de taxas
      <PmwInfoTooltip width="235px">
        <template #content>
          Reflete diretamente no cálculo de valores para a "tela preta" do
          financeiro.
        </template>
      </PmwInfoTooltip>
    </PmwHeading>

    <div class="form--row form--row__spacing-bigger">
      <div class="form--row mb-0">
        <!-- LETSBOOK -->
        <PmwFormInput
          :value="letsbook"
          :infoIcon="true"
          tooltipMinWidth="176"
          infoText="Fee do ecommerce letsbook"
          label="Letsbook"
          placeholder="-"
          class="form--input form--input__min"
          @input="$emit('changeLetsbook', $event)"
        />

        <!-- LETSBOOK TAXAS -->
        <div class="form--group-radio">
          <PmwParagraph
            size="paragraph-60"
            weight="medium"
            class="form--subtitle"
          >
            Taxas?
            <PmwInfoTooltip width="188px">
              <template #content>
                Se o fee é sob as taxas ou não.
              </template>
            </PmwInfoTooltip>
          </PmwParagraph>

          <div class="form--row-checklist">
            <PmwInputRadio
              :value="taxesLetsbook"
              :checked="taxesLetsbook"
              :inputValue="true"
              label="Sim"
              name="taxesLetsbook"
              @input="$emit('changeTaxesLetsbook', $event)"
            />

            <PmwInputRadio
              :value="taxesLetsbook"
              :checked="!taxesLetsbook"
              :inputValue="false"
              label="Não"
              name="taxesLetsbook"
              @input="$emit('changeTaxesLetsbook', $event)"
            />
          </div>
        </div>
      </div>
      <div class="form--row mb-0">
        <!-- CENTRAL -->
        <PmwFormInput
          :value="central"
          :infoIcon="true"
          tooltipMinWidth="213"
          infoText="Valor cobrado sobre as reservas provenientes à Central de Reservas."
          label="Central"
          placeholder="-"
          class="form--input form--input__min"
          @input="$emit('changeCentral', $event)"
        />

        <!-- CENTRAL - TAXAS -->
        <div class="form--group-radio">
          <PmwParagraph
            size="paragraph-60"
            weight="medium"
            class="form--subtitle"
          >
            Taxas?
            <PmwInfoTooltip width="190px">
              <template #content>
                Se o fee é sob as taxas ou não sobre as reservas provenientes à
                Central de Reservas
              </template>
            </PmwInfoTooltip>
          </PmwParagraph>

          <div class="form--row-checklist">
            <PmwInputRadio
              :value="taxesCentral"
              :checked="taxesCentral"
              :inputValue="true"
              label="Sim"
              name="taxesCentral"
              @input="$emit('changeTaxesCentral', $event)"
            />

            <PmwInputRadio
              :value="taxesCentral"
              :checked="!taxesCentral"
              :inputValue="false"
              label="Não"
              name="taxesCentral"
              @input="$emit('changeTaxesCentral', $event)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="form--row form--row__spacing-bigger mb-0">
      <!-- MULDIPAGG -->
      <PmwFormInput
        :value="mundipagg"
        :infoIcon="true"
        tooltipMinWidth="147"
        infoText="Valor cobrado referente às transações de gateway de pagamento"
        label="Mundipagg"
        placeholder="-"
        class="form--input form--input__min"
        @input="$emit('changeMundipagg', $event)"
      />

      <!-- SMS -->
      <PmwFormInput
        :value="sms"
        :infoIcon="true"
        tooltipMinWidth="271"
        infoText="Valor cobrado sobre o envio de SMS das confirmações, cancelamentos e reservas para o mesmo dia, sobre as reservas do Letsbook"
        label="SMS"
        placeholder="-"
        class="form--input form--input__min"
        @input="$emit('changeSms', $event)"
      />
    </div>

    <!-- MODAL DE CONFIRMAÇÃO PARA RESETAR PIX -->
    <PmwAlertModal
      v-model="showResetPixModal"
      icon="pmw-trash-can"
      title="Tem certeza que deseja resetar os dados de integração?"
      text="Ao confirmar, os dados atuais de integração serão excluídos permanentemente."
      cancelButtonColor="red-100"
      confirmButtonColor="red-100"
      confirmButtonText="Resetar dados"
      cancelButtonText="Voltar"
      closeButton
      @alert-modal-confirm="confirmResetPix"
    />
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwInputRadio from '@solucoes/components-lib-tmp/src/components/elements/PmwInputRadio'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'

/** Função de baixar arquivos */
import { downloadFile } from '@/helpers/file'

/** Função para padronizar a string */
import { standardizeFileName } from '@/helpers/string'

import { clampNumber } from '@/helpers/math'

import OnlyNumbersDirective from '@/directives/OnlyNumbersDirective'
import PmwFormField from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormField'

export default {
  name: 'SystemParameters',

  components: {
    PmwHeading,
    PmwParagraph,
    PmwFormInput,
    PmwFormSelect,
    PmwInputRadio,
    PmwInfoTooltip,
    PmwButton,
    PmwFormField,
    PmwAlertModal
  },

  /** Recebe funções do componente pai */
  inject: ['addAgeGroup', 'removeAgeGroup'],

  directives: {
    'only-numbers': OnlyNumbersDirective
  },

  props: {
    hotelName: {
      type: String,
      default: null
    },

    /** Lista de itens inclusos na integração de pontos */
    itemsIncludePoints: {
      type: Array,
      default: () => []
    },

    /** Lista de tarifas absolutas */
    absoluteRatesOptions: {
      type: Array,
      default: () => []
    },

    /** Gateway de pagamento */
    gateway: {
      type: [Object, String],
      default: () => {}
    },

    /** Mundipagg ID da Conta */
    mundipaggAccountID: {
      type: String,
      default: null
    },

    /** Mundipagg Google Pay */
    googlePayMerchantId: {
      type: String,
      default: null
    },

    /** Mundipagg Public Key */
    mundipagg1: {
      type: String,
      default: null
    },

    /** Mundipagg Secret Key */
    mundipagg2: {
      type: String,
      default: null
    },

    clearsale: {
      type: String,
      default: null
    },

    pointsType: {
      type: Object,
      default: () => {}
    },

    baseTariff: {
      type: Object,
      default: () => {}
    },

    acquirer: {
      type: [Object, String],
      default: () => {}
    },

    /** Estorno Automático */
    reversal: {
      type: Boolean,
      default: false
    },

    /** Anti-fraude */
    antiFraud: {
      type: Boolean,
      default: false
    },

    /** Habilitar boleto */
    ticket: {
      type: Boolean,
      default: false
    },

    /** Habilitar Pix */
    pix: {
      type: Boolean,
      default: false
    },

    starbank: {
      type: String,
      default: null
    },

    /** Parceiro Pix */
    gatewayPix: {
      type: Object,
      default: () => {}
    },

    /** Cielo Public Key */
    cieloMerchantKey: {
      type: String,
      default: null
    },

    /** Cielo Secret Key */
    cieloMerchantId: {
      type: String,
      default: null
    },

    /** Redecard Client ID */
    redecardClientId: {
      type: String,
      default: null
    },

    /** Redecard Client Secret */
    redecardClientSecret: {
      type: String,
      default: null
    },

    /** Tarifário do hotel (flutuante, absoluto) */
    tariff: {
      type: Object,
      default: () => {}
    },

    /** Pax composto */
    pax: {
      type: Object,
      default: () => {}
    },

    /** PMS do hotel */
    pms: {
      type: Object,
      default: () => {}
    },

    /** Mínimo de noites */
    minNights: {
      type: [String, Number],
      default: null
    },

    /** Número de adultos */
    minAdults: {
      type: [String, Number],
      default: null
    },

    /** Se aceita crianças */
    allowChildren: {
      type: Boolean,
      default: false
    },

    /** Idade mínima das crianças */
    minAgeChildren: {
      type: [String, Number],
      default: null
    },

    /** Idade máxima das crianças */
    maxAgeChildren: {
      type: [String, Number],
      default: null
    },

    /** Faixa etária das crianças */
    ageGroups: {
      type: Array,
      default: () => []
    },

    gtadId: {
      type: String,
      default: null
    },

    gtadAw: {
      type: String,
      default: null
    },

    /** OTA Insight ID */
    ota: {
      type: String,
      default: null
    },

    /** Telefone - País */
    phoneContry: {
      type: [Object, String],
      default: () => {}
    },

    /** Telefone - DDD */
    phonePrefix: {
      type: String,
      default: null
    },

    /** Telefone - Número */
    phoneNumber: {
      type: String,
      default: null
    },

    /** Bloquear pré checkin */
    blockCheckin: {
      type: Boolean,
      default: false
    },

    showHotel: {
      type: Boolean,
      default: false
    },

    url: {
      type: String,
      default: null
    },

    idIntegration: {
      type: [String, Number],
      default: null
    },

    userIntegration: {
      type: String,
      default: null
    },

    password: {
      type: String,
      default: null
    },

    letsbook: {
      type: [Number, String],
      default: null
    },

    taxesLetsbook: {
      type: Boolean,
      default: false
    },

    central: {
      type: String,
      default: null
    },

    taxesCentral: {
      type: Boolean,
      default: false
    },

    mundipagg: {
      type: [Number, String],
      default: null
    },

    sms: {
      type: String,
      default: null
    },

    /** Ecommerce trip advisor */
    tripAdvisorEcommerce: {
      type: Boolean,
      default: false
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    },

    /** Lista de gateways de pagamento */
    gatewayPayments: {
      type: Array,
      default: () => []
    },

    /** Lista de acquirer */
    acquirerList: {
      type: Array,
      default: () => []
    },

    /** Lista de tarifas */
    tariffList: {
      type: Array,
      default: () => []
    },

    /** Lista de parceiros pix */
    gatewayPixList: {
      type: Array,
      default: () => []
    },

    /** Lista de tipos de pax */
    paxList: {
      type: Array,
      default: () => []
    },

    /** Lista de pms */
    pmsList: {
      type: Array,
      default: () => []
    },

    /** Tipos de pax de crianças */
    childrenTypes: {
      type: Array,
      default: () => []
    },

    /** Tipos de OTAs */
    otaTypes: {
      type: Array,
      default: () => []
    },

    /** Tipos de OTAs */
    otaInsights: {
      type: Array,
      default: () => []
    },

    /** Lista de DDI */
    ddi: {
      type: Array,
      default: () => []
    },

    /** Exibir modal de processos */
    showProcessRates: {
      type: Boolean,
      default: false
    },

    hasPoints: {
      type: Boolean,
      default: false
    },

    /** Seleção de pontos */
    pointsSelection: {
      type: Number,
      default: 0
    },

    pointsPerNight: {
      type: [Number, String],
      default: null
    },

    pointsPerReal: {
      type: [Number, String],
      default: null
    },

    preCheckinLink: {
      type: String,
      default: null
    },

    minRateValue: {
      type: Number,
      default: 50
    },

    /** Moeda base do hotel */
    currency: {
      type: String
    },

    hasChatbotCartDrop: {
      type: Boolean,
      default: false
    },

    /** Seleção de pontos */
    chatbotCartDrop: {
      type: Number
    },

    starbankFill: {
      type: Boolean,
      default: false
    },

    cieloMerchantKeyFill: {
      type: Boolean,
      default: false
    },

    /** Tipo de hotel */
    type: {
      type: Object,
      default: () => {}
    },

    /** Lista de tipos de hotéis */
    types: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      chatbotCartDropOptions: [],

      /** Se a configuração do id_starkbank foi realizada com sucesso */
      starkbankConfigured: false,

      /** Controla a exibição do modal de confirmação para resetar PIX */
      showResetPixModal: false
    }
  },

  computed: {
    /** Verifica se a tarifa é Absoluta */
    isAbsolute() {
      /** Retorna true se a tarifa for Absoluta (não flutuante) */
      return this.tariff?.value !== false
    },

    /** Starkbank configurado */
    disabledStarkbankButtons() {
      return (
        this.hotelId === null || this.starbankFill || this.starkbankConfigured
      )
    }
  },

  watch: {
    ageGroups: {
      handler: function() {
        this.$emit('changeAgeGroups', this.ageGroups)
      },
      deep: true
    }
  },

  created() {
    /** Pegar o id do hotel (se for edição) */
    this.hotelId = this.$route.params.id || null

    this.$hotel.getChatbotIntegrations().then((response) => {
      const { data } = response

      if (data.length) {
        this.chatbotCartDropOptions = data.map((item) => {
          return {
            text: item.nome,
            value: item.codigo
          }
        })
      }
    })
  },

  methods: {
    /** Exibe o modal de confirmação para resetar PIX */
    showResetConfirmation() {
      this.showResetPixModal = true
    },

    /** Confirma e executa o reset dos dados do PIX */
    confirmResetPix() {
      this.$emit('resetPix')
    },

    /** Reseta os dados do PIX desabilitando-o */
    resetPixData() {
      this.$emit('changePix', false)
    },

    /** Faz o download da public key do Starkbank */
    publicKey() {
      /** Remove caracteres especiais e substitui espaços por - */
      const hotelName = standardizeFileName(this.hotelName)

      this.$hotel
        .starkbankPublicKey(this.hotelId)
        .then((response) => {
          /** Baixar arquivo */
          downloadFile(
            response.data,
            `${hotelName ? hotelName + '-' : ''}public-key.pem`,
            'application/x-pem-file'
          )
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Processamento realizado com sucesso.'
          })
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        })
    },

    /** Realiza a configuração de integração com Starkbank */
    validateIntegration() {
      this.$hotel
        .integrationStarkbank(parseInt(this.hotelId), this.starbank)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Processamento realizado com sucesso.'
          })

          this.starkbankConfigured = true
        })
        .catch((error) => {
          const message =
            error.response.status === 400
              ? error.messages
              : 'Verifique os dados inseridos. Se os dados estiverem corretos, entrar em contato com o Suporte de Letsbook.'

          this.$bus.$emit('show-alert-chip', {
            message: message
          })
        })
    },

    /**
     * Ajusta a idade mínima ou máxima das crianças ao perder o foco,
     * garantindo que fique dentro dos limites e atualizando os grupos
     *
     * @param {string} type: Define o campo a ajustar: 'Min' ou 'Max' (padrão: 'Max')
     */
    blurChildrenAge(type = 'Max') {
      const isMin = type === 'Min'
      const value = isMin ? this.minAgeChildren : this.maxAgeChildren
      const min = isMin ? 0 : this.minAgeChildren
      const max = isMin ? this.maxAgeChildren : undefined

      const clampedValue = clampNumber(value, min, max)

      this.$emit(`change${type}AgeChildren`, clampedValue)

      this.clampAgeGroups()
    },

    /**
     * Mantém idade mínima e máxima de cada grupo dentro dos limites
     * definidos por minAgeChildren e maxAgeChildren, ignorando valores nulos
     */
    clampAgeGroups() {
      this.ageGroups.forEach((group) => {
        ;['idadeMinima', 'idadeMaxima'].forEach((field) => {
          if (group[field] !== null) {
            group[field] = clampNumber(
              group[field],
              this.minAgeChildren,
              this.maxAgeChildren
            )
          }
        })
      })
    },

    clampNumber: clampNumber
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }
    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}

.pmw-info-tooltip {
  ::v-deep {
    .pmw-custom-tooltip {
      display: flex;
      gap: 5px;
      color: $pmw-gray-dark;
      font-size: font-size('size-small');
      line-height: 18px;
      text-align: left;
    }
  }
  .pmw-custom-tooltip--arrow {
    display: none;
  }
}

.form {
  &--container-radio {
    display: flex;
    gap: 57px;
  }

  &--input {
    max-width: 179px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__base-tariff {
      max-width: 350px;
    }

    &__oversized {
      max-width: 205px;
    }

    &__lower {
      max-width: 145px;
    }

    &__min {
      max-width: 130px;
    }

    &__age {
      max-width: 75px;
    }

    &__url {
      max-width: 309px;
    }

    &__phone-country {
      max-width: 193px;
    }

    &__prefix {
      max-width: 76px;
    }

    &__phone-number {
      max-width: 137px;
    }

    &__hotel-type {
      max-width: 250px;
    }

    &__payment-type {
      width: 175px;
    }
  }

  &--info {
    line-height: 18px;
    margin-bottom: 24px;
    color: $pmw-gray-dark;
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: unset;
    gap: 20px;
    margin-bottom: 29px;

    &__spacing-bigger {
      gap: 54px;
    }

    &__wrap {
      flex-wrap: wrap;
      gap: 29px 54px;
    }

    &--others-config {
      align-items: flex-start;

      @media (max-width: 1300px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }

    &__margin-bigger {
      margin-bottom: 42px;
    }

    &__block-checkin {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 0 !important;

      .example-link {
        display: flex;
        flex-direction: column;
        max-width: 411px;
        min-width: 211px;

        &--title {
          line-height: 21px;
          text-align: left;
          text-underline-position: from-font;
          text-decoration-skip-ink: none;
        }

        &--content {
          line-height: 21px;
          text-align: left;
          text-underline-position: from-font;
          text-decoration-skip-ink: none;
          word-break: break-word;

          strong {
            font-weight: 700;
          }
        }
      }
    }

    @media (max-width: 1300px) {
      &__block-checkin {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    &__message {
      font-size: font-size('size-medium');
      font-size: font-weight('weight-medium');
    }
  }

  &--group-radio {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 23px;

    p {
      width: 100%;
      margin-top: 0px;
      margin-bottom: 0px !important;
    }

    & > div {
      margin-bottom: 10px;
    }

    &__margin-bigger {
      margin-bottom: 29px;
    }
  }

  &--row-checklist {
    display: flex;
    align-items: center;
    gap: 23px;
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 22px;
    position: relative;
  }

  &--asterisk {
    color: pmw-colors('red-100');
  }

  &--button {
    width: auto;
    align-self: center;
  }
}

.chatbot-block {
  align-items: flex-start;

  &--radio {
    display: grid;
    grid-template-rows: auto 1fr;
    height: 64px;

    &-content {
      display: flex;
      align-items: center;
      gap: 0 16px;

      &__disabled {
        opacity: 0.7;
        pointer-events: none;
      }
    }
  }
}

.button {
  &__outline ::v-deep {
    .pmw-button--icon__left {
      gap: 10px;
    }
  }
}

.pmw-input-radio ::v-deep {
  input:checked ~ {
    .pmw-input-radio--fake-radio {
      border-color: $pmw-blue;

      &:before {
        background-color: $pmw-blue;
      }
    }
  }
}

.input--container {
  display: flex;
  flex-direction: row;
  gap: 20px;

  &__select {
    min-width: 150px;
  }
}
</style>
